import { makeStyles } from "@material-ui/core/styles";
import { Height } from "@material-ui/icons";

export const useStyles = makeStyles((theme) => ({
	spacedInput: {
		marginTop: theme.spacing(2),
	},
}));